import { TablePagination } from "@mui/material";
import { FC } from "react";

interface Props {
  count: number;
  page: number;
  handleChangePage: (event: unknown, newPage: number) => void;
  rowsPerPage: number;
  handleChangeRowsPerPage: (event: React.ChangeEvent<HTMLInputElement>) => void;
  options?: number[];
}

const SingleOrgPagination: FC<Props> = ({
  count,
  page,
  rowsPerPage,
  handleChangeRowsPerPage,
  handleChangePage,
  options = [],
}) => {
  return (
    <TablePagination
      component="div"
      count={count}
      page={page}
      onPageChange={handleChangePage}
      rowsPerPage={rowsPerPage}
      rowsPerPageOptions={options}
      onRowsPerPageChange={handleChangeRowsPerPage}
      labelRowsPerPage="Filas por página"
      labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
      sx={{
        marginLeft: "auto", // Alinea a la derecha
        backgroundColor: "#336B87", // Mismo color de fondo que la cabecera
        color: "white", // Texto blanco
        fontFamily: "Montserrat", // Fuente Montserrat
        borderRadius: "10px",
        width: "100%", // Que ocupe todo el ancho de la tabla
        justifyContent: "flex-end", // Justificar todo el contenido a la derecha
        display: "flex", // Hace que el contenedor sea un flexbox
        "& .MuiTablePagination-spacer": {
          display: "none", // Elimina el espacio vacío
        },
        "& .MuiTablePagination-actions": {
          color: "white", // Hace que las flechas sean blancas
        },
        "& .MuiIconButton-root": {
          color: "white", // Cambia el color de las flechas a blanco
        },
        "& .MuiTablePagination-select, .MuiTablePagination-selectIcon": {
          color: "white", // Cambia el icono del selector de filas a blanco
        },
        "& .MuiIconButton-root.Mui-disabled": {
          opacity: 0.5, // Aplica opacidad 50% a los botones deshabilitados (flechas)
        },
      }}
    />
  );
};

export default SingleOrgPagination;
